import { mapMutations, mapState, mapGetters, mapActions } from "vuex";
import { DATE_RANGES_FROM_SELECTOR, DATE_PICKER_COMPARE_TITLES, getDatePickerRangeCompare, getDatePickerUIObjectFromDateRange, momentWeekType } from "@/utils/datepicker";
import moment from "moment";
import DashboardV2Mixin from "@/mixins/DashboardV2Mixin.vue";
import { EVENTS, APP_PERIOD_DROPDOWN_ELEMENTS } from "@/utils/constants";
import AppDropdown from "@/components/AppDropdown.vue";
import AppButtonRadioGroup from "@/components/AppButtonRadioGroup.vue";
import CurrencyFilter from "@/components/new-filters/CurrencyFilter.vue";
import FlexColumn from "@/components/FlexColumn.vue";
import DateValue from "@/components/tableElements/DateValue.vue";
import LiteTableMixin from "@/mixins/LiteTableMixin.vue";
import PeriodTable from "@/components/search_funnel/PeriodTable.vue";
import OpportunitiesPeriodTable from "../components/search_funnel/OpportunitiesPeriodTable.vue";
import ProductTable from "@/components/search_funnel/ProductTable.vue";
import SearchFunnelFilters from "@/components/SearchFunnelFilters.vue";
import PeriodControllers from "@/components/PeriodControllers.vue";
import NavigationTabs from "@/components/NavigationTabs.vue";
import { FLOATING_COMPOUND_TABLE_STATES, PPC_EXTRA_FILTERS } from "../utils/constants";
export default {
  name: "SearchFunnelPage",
  components: {
    AppDropdown,
    AppButtonRadioGroup,
    CurrencyFilter,
    FlexColumn,
    DateValue,
    LiteTableMixin,
    PeriodTable,
    SearchFunnelFilters,
    PeriodControllers,
    ProductTable,
    OpportunitiesPeriodTable,
    NavigationTabs
  },
  mixins: [LiteTableMixin, DashboardV2Mixin],
  created() {
    this.originalWeekType = this.getSystemWeekType;
    this.$store.dispatch("setWeekTypeConfig", "monday");
  },
  beforeUnmount() {
    this.$store.dispatch("setWeekTypeConfig", this.originalWeekType);
    window.$bus.off(EVENTS.REFRESH_SEARCH_FUNNEL, () => this.refreshAllKpis());
  },
  async mounted() {
    this.datePickerCommitterFunction = this.searchFunnelSetProductTablePeriod;
    this.$store.dispatch("searchFunnelSetDefaultCurrency");
    window.$bus.on(EVENTS.REFRESH_SEARCH_FUNNEL, () => this.refreshAllKpis());
    const renderingStart = performance.now();
    await this.initializeSellersFilter(this.searchFunnelSellersFilterSet);
    await this.refreshsearchFunnelSellersSubFilters();
    this.$store.dispatch("searchFunnelSetProductTableGroupByElements");
    window.$bus.trigger(EVENTS.FLOATING_COMPOUND_TABLE_OPEN_COLLAPSE);
    this.applyPeriodForDatePicker(this.periodGroupBy);
    this.refreshAllKpis();
    const renderingEnd = performance.now();
    console.log(`[Perf][Market Insights Rendering]: ${(renderingEnd - renderingStart) / 1000} s`);
    window.$bus.on(EVENTS.REFRESH_SEARCH_FUNNEL_SELLERS_SUB_FILTERS, this.refreshsearchFunnelSellersSubFilters);
    window.$bus.on(EVENTS.REFRESH_SEARCH_FUNNEL_MARKETPLACES_SUB_FILTERS, this.refreshsearchFunnelMarketPlacesSubFilters);
    window.$bus.on(EVENTS.REFRESH_SEARCH_FUNNEL_PRODUCTS_SUB_FILTERS, this.initializeKeywordsFilters);
    window.$bus.on(EVENTS.REFRESH_SEARCH_FUNNEL_KEYWORD_TYPE_SUB_FILTERS, this.initializeKeywordsFilters);
    this.checkLocalStorageOnMarketplaceFilter = false;
  },
  data(ctx) {
    return {
      today: moment(),
      sellers: [],
      marketplaces: [],
      periodTableLoading: true,
      productTableLoading: true,
      mediatorRefreshers: {
        PERIOD_TABLE: this.refreshPeriodTable,
        PRODUCT_TABLE: this.refreshProductTable
      },
      DATE_RANGES_FROM_SELECTOR,
      checkLocalStorageOnMarketplaceFilter: true,
      FLOATING_COMPOUND_TABLE_STATES,
      secondaryFilterInitializers: {
        [PPC_EXTRA_FILTERS.CAMPAIGN]: () => ctx.initializeCampaignsFilters({
          sellers: ctx.sellers_filter.filterValues,
          sales_channel: ctx.marketplaces_filter.filterValues,
          ...ctx.ppcV2FilterRelationParams()
        }, ctx.campaigns, "ppc/v2"),
        [PPC_EXTRA_FILTERS.MATCH_TYPE]: () => ctx.initializeMatchTypesFilters({
          sellers: ctx.sellers_filter.filterValues,
          sales_channel: ctx.marketplaces_filter.filterValues
        }, ctx.match_types, "ppc/v2"),
        [PPC_EXTRA_FILTERS.TARGETING]: () => ctx.initializeTargetingsFilters({
          sellers: ctx.sellers_filter.filterValues,
          sales_channel: ctx.marketplaces_filter.filterValues
        }, ctx.targetings, "ppc/v2"),
        [PPC_EXTRA_FILTERS.AD_FORMAT]: () => ctx.initializeAdFormatsFilters({
          sellers: ctx.sellers_filter.filterValues,
          sales_channel: ctx.marketplaces_filter.filterValues
        }, ctx.ad_formats, "ppc/v2"),
        [PPC_EXTRA_FILTERS.PORTFOLIO]: () => ctx.initializePortfoliosFilters({
          sellers: ctx.sellers_filter.filterValues,
          sales_channel: ctx.marketplaces_filter.filterValues
        }, ctx.portfolios, "ppc/v2"),
        [PPC_EXTRA_FILTERS.CAMPAIGN_GROUP]: () => ctx.initializeCampaignGroupsFilters({
          sellers: ctx.sellers_filter.filterValues,
          sales_channel: ctx.marketplaces_filter.filterValues,
          ...ctx.ppcV2FilterRelationParams()
        }, ctx.campaign_groups, "ppc/v2")
      }
    };
  },
  computed: {
    ...mapState({
      currentPeriod: state => state.search_funnel.currentPeriod,
      periodSelectorOptions: state => state.search_funnel.periodSelectorOptions,
      tabs: state => state.search_funnel.tabs,
      productTable: state => state.search_funnel.product_table,
      productTableGroupBy: state => state.search_funnel.product_table.group_by_text,
      currentTabValue: state => state.search_funnel.currentTabValue,
      floatingTableState: state => state.search_funnel.product_table.state,
      currencies: state => state.search_funnel.currencies,
      sellers_filter: state => state.search_funnel.sellers_filter,
      marketplaces_filter: state => state.search_funnel.marketplaces_filter,
      products: state => state.search_funnel.products,
      targetings: state => state.search_funnel.targetings,
      targeting_types: state => state.search_funnel.targeting_types
    }),
    ...mapGetters(["searchFunnelGetPeriod", "searchFunnelGetPeriodCategory", "searchFunnelGetTab", "getSystemWeekType", "isUserInBetaAccessGroup", "searchFunnelGetPeriodOptions"]),
    currentSellerIds() {
      return this.sellers_filter.filterValues;
    },
    currentMarketplaceIds() {
      return this.marketplaces_filter.selectedValues;
    },
    period: {
      set(value) {
        this.$store.dispatch("searchFunnelSetPeriod", value);
        this.applyPeriodForDatePicker(this.periodGroupBy, this.periodCategory);
        this.refreshMediator(["PERIOD_TABLE", "PRODUCT_TABLE"]);
      },
      get() {
        return this.searchFunnelGetPeriod();
      }
    },
    periodCategory: {
      set(value) {
        this.applyPeriodCategoryForDatePicker(this.datePickerDate, value);
        this.$store.dispatch("searchFunnelSetPeriodCategory", value);
      },
      get() {
        return this.searchFunnelGetPeriodCategory();
      }
    },
    tab: {
      async set(value) {
        this.$store.dispatch("searchFunnelSetTab", {
          tabIndex: value,
          tabValue: this.tabs[value].value
        });
      },
      get() {
        return this.searchFunnelGetTab();
      }
    },
    periodGroupBy() {
      return this.getPeriodGroupFromCurrentPeriod(this.currentPeriod, this.period);
    },
    getCurrentPeriodDate() {
      if (this.period === APP_PERIOD_DROPDOWN_ELEMENTS.WEEKLY.value) {
        return momentWeekType["monday"]();
      }
      return this.currentPeriod[this.period].date;
    },
    periodOptions() {
      return this.searchFunnelGetPeriodOptions;
    },
    targetingTypeOptions() {
      const allTypes = {
        key: 'ALL',
        text: 'All types',
        class: 'type-all'
      };
      const branded = this.targeting_types.defaultList.find(i => i.short_name === 'Branded');
      const nonBranded = this.targeting_types.defaultList.find(i => i.short_name === 'Non-branded');
      const competitors = this.targeting_types.defaultList.find(i => i.short_name === 'Competitors');
      return [allTypes, branded, nonBranded, competitors].filter(Boolean).map(item => item.key === 'ALL' ? item : {
        ...item,
        text: item.short_name,
        class: `type-${item.short_name.toLowerCase().replace(' ', '-')}`
      });
    },
    selectedTargetingType() {
      return this.targeting_types.filterState.selected[0]?.key ?? 'ALL';
    },
    datePickerDate() {
      return this.productTable[this.currentTabValue].period;
    }
  },
  methods: {
    ...mapMutations(["searchFunnelSellersFilterSet", "searchFunnelMarketplacesFilterSet", "searchFunnelSetProductTablePeriod"]),
    ...mapActions(["getSearchFunnelKeywords"]),
    handleErrorOccured() {
      this.announceNoAccounts();
      this.periodTableLoading = false;
    },
    async onTargetingTypeChange(key) {
      if (key === 'ALL') {
        this.targeting_types.clear();
      } else {
        this.targeting_types.selectOnly({
          key
        }, 'key');
      }
      this.targeting_types.apply();
      await this.initializeKeywordsFilters();
      this.refreshAllKpis();
    },
    async refreshPeriodTable() {
      this.periodTableLoading = true;
      await this.$store.dispatch("searchFunnelFetchPeriodTableData");
      this.periodTableLoading = false;
    },
    async refreshMediator(refresheeList) {
      const perf = [];
      perf.push(performance.now());
      //console.log("Refreshee List", refresheeList);
      refresheeList.forEach(refreshee => {
        this.mediatorRefreshers[refreshee]();
      });
      perf.push(performance.now());

      //console.log(`[perf][refreshMediator]: ${(perf[1] - perf[0]) / 1000} s`);
    },
    async refreshProductTable() {
      this.productTableLoading = true;
      let previousPeriodCategory = this.periodCategory;
      this.periodCategory = "prev_period";
      const groupByFetch = this.productTable[this.currentTabValue].data[this.productTableGroupBy]?.fetch;
      if (groupByFetch) await this.$store.dispatch(groupByFetch);
      this.periodCategory = previousPeriodCategory;
      this.productTableLoading = false;
    },
    async handleDateChange(date) {
      if (!date) {
        date = this.applyPeriodForDatePicker(this.periodGroupBy, this.periodCategory);
      }
      this.storeDatePickerDate(date);
      await this.refreshMediator(["PRODUCT_TABLE"]);
    },
    // Clear any evolution row selection without refetching.
    restoreEvolutionTable() {
      this.$store.commit("searchFunnelDeselectPeriodTable");
    },
    handleProductTableSort({
      sort,
      direction
    }) {
      this.$store.dispatch("searchFunnelSetProductTableSort", {
        sort,
        direction
      });
      this.refreshMediator(["PRODUCT_TABLE"]);
    },
    handleSetPeriodTable(date) {
      this.handleSetLiteTablePeriod(date, this.period, this.handleDateChange, this.datePickerCompareTitle(this.periodCategory));
    },
    refreshAllKpis() {
      this.refreshMediator(["PERIOD_TABLE", "PRODUCT_TABLE"]);
    },
    handleApplyForCurrencyChange() {
      if (this.currencies.isModified) {
        this.currencies.apply();
        this.$store.dispatch("currencyConfigSetCurrency", this.currencies.filterValues[0]);
        this.refreshAllKpis();
      }
    },
    async refreshsearchFunnelSellersSubFilters() {
      await this.initializeMarketplacesFilter(this.searchFunnelMarketplacesFilterSet, this.checkLocalStorageOnMarketplaceFilter);
      this.marketplaces_filter._key = "sales_channel";
      await this.refreshsearchFunnelMarketPlacesSubFilters();
    },
    async refreshsearchFunnelMarketPlacesSubFilters() {
      await this.products.clear();
      await this.initializeProductsFilters({
        sellers: this.currentSellerIds,
        sales_channel: this.currentMarketplaceIds
      }, this.products, "dashboard/v2");
      await this.initializeKeywordsFilters();
    },
    async initializeKeywordsFilters() {
      const keywords_result = await this.getSearchFunnelKeywords();
      this.targetings.initialize({
        list: keywords_result?.slice(0, 100),
        selected: [],
        key: "targeting",
        name: "targetings_filter",
        asyncSearcher: params => this.getSearchFunnelKeywords({
          ...params
        })
      });
    }
  }
};